<template>
	<div id="video" class="agora_player">
    	<div class="global_pointer" :class="['player_volume', mute?'':'unmuted']" @click="changeVolume"></div>
		<img
			v-if="isShow"
			class="play-button"
			@click="play"
			:src="require('@/assets/imgs/player/play.png')"
			alt="Play"
		/>
		<div id="remote_video_panel" class="video-view">
			<div id="remote_video" class="video-placeholder"></div>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    streamInstance: {
      type: Object,
      default() {
        return {};
      },
    },
    playAgoraState: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      playAgora: false,
      isShow: true,
	  mute: true,
    };
  },
  watch: {
    playAgoraState: {
      handler(newVal) {
        this.playAgora = newVal;
      },
      immediate: true,
    },
    streamInstance: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.play();
          this.setTimer();
        }
      },
    },
  },
  inject: ['reload'],
  methods: {
    play() {
      if (!this.streamInstance) {
        this.reload();
        return;
      }
      this.isShow = false;
      this.streamInstance.stop();
      const that = this;
		this.$emit('play');
      this.streamInstance.play('video', { muted: this.mute }, (e) => {
        if (e && e.status === 'paused') {
          that.streamInstance.resume();
        }
      });
		setTimeout(() => {
			this.$isLogin();
		}, 3000);
    },
    setTimer() {
      const timeId = setInterval(() => {
        const canvasEl = document.getElementsByTagName('canvas');
        if (canvasEl && canvasEl.length > 0 && canvasEl[0]) {
          canvasEl[0].style.objectFit = 'cover';
          clearInterval(timeId);
        }
      }, 1000);
    },
    changeVolume() {
      this.mute = !this.mute;
	  this.streamInstance.stop();
      if (this.mute) {
        this.streamInstance.muteAudio();
      } else {
        this.streamInstance.unmuteAudio();
      }
	  this.streamInstance.play('video', { muted: this.mute });
    },
  },
};
</script>

<style scoped lang="less" scoped>
.agora_player {
	width: 100% !important;
	height: 100% !important;
  background: rgba(53, 50, 50, 0.8);
  /deep/video{
	left: 0;
	top: 0;
  }
  /deep/canvas{
	left: 0 !important;
  }
}
.play-button {
	color: #fff;
	width: 48px;
  height: 48px;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 20;
}
.player_volume{
  position: absolute;
  top: 154px;
  right: 14px;
  width: 44px;
  height: 44px;
  z-index: 100;
  background-size: 24px auto;
  background-image: url('../../assets/imgs/room/muted.png');
  background-repeat: no-repeat;
  background-position: center center;
  &.unmuted{
    background-image: url('../../assets/imgs/room/unmuted.png');
    background-size: 24px auto;
  }
}
</style>
